import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/openapi/manage/v1/login',
    method: 'post',
    data
  })
}

export function getInfo(data) {
  return request({
    url: '/api/manage/v1/manager/profile/info',
    method: 'post',
    data: '{}'
  })
}

